import { Box } from "@mui/material";
import React from "react";

/**
 * Circular clue index used beside each word in {@link ../../puzzles/crossword/components/CrossWordCluesPanel}
 * and inline in story “find the word” blanks. Styles must stay in sync.
 */
export const STORY_PANEL_CLUE_WORD_NUMBER_SX = {
    width: "21px",
    height: "21px",
    minWidth: "21px",
    minHeight: "21px",
    flexShrink: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#C4FFE0",
    borderRadius: "50%",
    border: "1px solid #2E8B57",
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "#000",
    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
};

/** Selected clue in story play / word panel — orange circle */
export const STORY_CLUE_CIRCLE_SELECTED_SX = {
    backgroundColor: "#FF9800",
    border: "1px solid #E65100",
    color: "#1a1a1a",
    fontWeight: 700,
    boxShadow: "0 2px 8px rgba(230, 81, 0, 0.4)",
};

/** @param {{ children: React.ReactNode, sx?: import('@mui/system').SxProps }} props */
export default function StoryClueNumberCircle({ children, sx }) {
    return (
        <Box component="span" sx={[STORY_PANEL_CLUE_WORD_NUMBER_SX, ...(sx ? [sx] : [])]}>{children}</Box>
    );
}
